import { Actions } from "../../../../components/Actions/Actions";
import { useOrderActions } from "../../../../hooks";
import { EmailModal } from "./EmailModal";

interface OrderActionsSectionProps {
	orderNumber: string;
}

export const OrderActionsSection = ({ orderNumber }: OrderActionsSectionProps): JSX.Element => {
	const { actionsRows, isEmailModalOpen, hideEmailModal } = useOrderActions(orderNumber);

	return (
		<>
			<Actions actionsRows={actionsRows} />
			<EmailModal isEmailModalOpen={isEmailModalOpen} hideEmailModal={hideEmailModal} />
		</>
	);
};
